/** TR veya EN biçimli metni sayıya çevirir; belirsiz/geçersizse null. */
export function parseTR(text: string): number | null {
  const t = text.trim();
  if (!t) return null;
  if (!/^-?[\d.,]+$/.test(t) || /--/.test(t)) return null;
  const commas = (t.match(/,/g) ?? []).length;
  const dots = (t.match(/\./g) ?? []).length;
  let normalized: string;
  if (commas > 1) return null;
  if (commas === 1) normalized = t.replace(/\./g, "").replace(",", ".");            // 1.234,56
  else if (dots > 1) {                                                              // 1.234.567 (binlik) — her grup 3 hane olmalı
    const parts = t.replace("-", "").split(".");
    if (!parts.slice(1).every((p) => p.length === 3)) return null;
    normalized = t.replace(/\./g, "");
  } else normalized = t;                                                            // 12.5 veya 1234
  const n = Number(normalized);
  return Number.isFinite(n) ? n : null;
}
